import Box from '@mui/system/Box';
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import CircularProgressBar from '../../../common/CircularProgress';
import { AppState } from '../../../store';
import { onGetDashboardData } from '../../../store/actions/dashboardAction';
import DashboardItem from './DashboardItem';

interface DashboardCompProps {
	selectedListItem: string;
	setSelectedListItemHandler: (path: string) => void;
	setOpen: (open: boolean) => void;
}

const DashboardComp = (props: DashboardCompProps) => {
	const { setSelectedListItemHandler } = props;

	const { data } = useSelector<AppState, AppState['dashboard']>(
		({ dashboard }) => dashboard,
	);
	const { loading } = useSelector<AppState, AppState['common']>(
		({ common }) => common,
	);

	const dispatch = useDispatch()
	useEffect(() => {
		if(!data)
			dispatch(onGetDashboardData())
	}, [dispatch, data])

	if(loading && !data) {
		return <Box display="flex" justifyContent="center"><CircularProgressBar /></Box>
	}

	return <DashboardItem
		data={data}
		setSelectedListItemHandler={setSelectedListItemHandler}
	/>
}

export default DashboardComp;
